import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        {/* ---------- brand ---------- */}
        <div className="footer-brand">
          <div className="footer-logo"><span></span>ASK DEVELOPERS</div>
          <p className="footer-tagline">
            Certified Web Developer &amp; IoT enthusiast building fast, thoughtful digital experiences.
          </p>
          <div className="footer-socials">
            <a href="www.linkedin.com/in/abdul-samad-kamran-2b13a8383" target="_blank" rel="noreferrer" aria-label="LinkedIn">in</a>
            <a href="#" target="_blank" rel="noreferrer" aria-label="GitHub">gh</a>
            <a href="#" target="_blank" rel="noreferrer" aria-label="Twitter / X">tw</a>
          </div>
        </div>

        {/* ---------- services ---------- */}
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li>Web Development</li>
            <li>UI / Frontend Design</li>
            <li>Backend &amp; APIs</li>
            <li>IoT Development</li>
          </ul>
        </div>

        {/* ---------- quick links ---------- */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/project">Projects</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* ---------- contact ---------- */}
        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:askdevelopers8@email.com">askdevelopers8@email.com</a></li>
            <li><a href="https://wa.me/923114386437">+92 311 4386437</a></li>
            <li className="footer-static">Based anywhere · Remote</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 Abdulsamad Kamran. All rights reserved.</p>
        <a href="#home" className="back-to-top">Back to top ↑</a>
      </div>
    </footer>
  )
}

export default Footer
